import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import types from '../../store/globaltypes'

export default {
  name: 'calendar',
  components: {},
  props: [],
  data () {
    return {
      lastLoadedMonth: null,
      firstLoadedMonth: null,
      isLoadingFuture: false,
      isLoadingPast: false
    }
  },
  computed: {
    ...mapGetters({
      planning: types.planning.getters.all,
      locale: types.user.getters.localeCode
    }),
    ...mapState({
      calendarCollapsed: state => state.ui.calendar.calendarCollapsed,
      isDataLoaded: state => state.ui.calendar.isDataLoaded && state.ui.crops.isDataLoaded
    }),
    isLoading () {
      return this.isLoadingPast || this.isLoadingFuture
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations({
      setCalendarCollapsed: types.ui.mutations.setCalendarCollapsed,
      setSelectedDate: types.ui.mutations.setSelectedDate
    }),
    ...mapActions({
      load: types.planning.actions.load,
      loadPast: types.planning.actions.loadPast
    }),
    toggleCalendarCollapsed () {
      this.setCalendarCollapsed(!this.calendarCollapsed)
    },
    checkDate (date) {
      const startOfMonth = this.moment(date).startOf('month')
      date = this.moment(date)
      if (date.isSame(startOfMonth)) this.loadMonth(startOfMonth)
      return this.planning.some(item => date.isSame(item.period, 'day'))
    },
    async loadMonth (startOfMonth) {
      if (!this.isDataLoaded) return
      if (!this.lastLoadedMonth || startOfMonth.isAfter(this.lastLoadedMonth)) {
        this.lastLoadedMonth = startOfMonth
        this.isLoadingFuture = true
        const endOfMonth = this.moment(startOfMonth).endOf('month')
        await this.load(endOfMonth.toDate())
        this.isLoadingFuture = false
      }
      if (!this.firstLoadedMonth || startOfMonth.isBefore(this.firstLoadedMonth)) {
        this.firstLoadedMonth = startOfMonth
        this.isLoadingPast = true
        await this.loadPast(startOfMonth.toDate())
        this.isLoadingPast = false
      }
    },
    dateSelected (date) {
      if (this.checkDate(date)) {
        this.setSelectedDate(this.moment(date))
      }
    }
  },
  watch: {
    filter (val) {
      if (val) this.filterCrops(this.cropGroups[val - 1])
      else this.filterCrops(null)
    }
  }
}
